import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/employee'

export const employeeService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    getPagedList,
    getAssignedUser,
    getAllUserWithoutEmployee,
    getEmployeeByCurrentUser,
    getEmployesByDepartment,
    findAllMyDepartmentSupervisor
};


function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}

function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

function getAssignedUser(id) {
    return utilHelper.doRequest(`${relativeUrl}/getAssignedUser/${id}`, 'GET')
}

function getAllUserWithoutEmployee() {
    return utilHelper.doRequest(`${relativeUrl}/getAllUserWithoutEmployee`, 'GET')
}

function getEmployeeByCurrentUser() {
    return utilHelper.doRequest(`${relativeUrl}/getEmployeeByCurrentUser`, 'GET')
}

function getEmployesByDepartment(data) {
    return utilHelper.doRequest(`${relativeUrl}/findAllEmployeeByDepartment`, 'POST', data)
}

function findAllMyDepartmentSupervisor() {
    return utilHelper.doRequest(`${relativeUrl}/findAllMyDepartmentSupervisor`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}